import * as PrepaidApi from '@Modules/cardManagementSystem/prepaid/api/PrepaidApi';
import OwnerFormUI from '@Modules/terminalManagementSystem/merchant/components/formsUI/merchantRequest/OwnerFormUI';
import { useToast } from '@chakra-ui/react';
import { useMutation, useQuery } from '@tanstack/react-query';
import OwnerFormMeta from './OwnerMeta';

const OwnerFormHandler = () => {    
  const toast = useToast();
  const { isLoading } = useQuery({
    queryKey: ['centerOwner'],
    queryFn:  async () => {
      return PrepaidApi.getAddress
    },
    onSuccess: (data) => {
      // console.log('Response: ', data);
    },
    onError: (error) => {
      // console.log('Error: ', error);
    },
  });
  
  const { mutateAsync, isLoading: isSubmitting } = useMutation( PrepaidApi.updateAddress, {
    onSuccess: (data) => {
      // console.log('Response: ', data);
      toast({
        position: 'top-right',
        title: 'Lorem ipsum dolor sit amet.',
        isClosable: true,
        status: 'success',
      });
    },
    onError: (error) => {
      console.log('Error: ', error);
    },
  });
  
  const onSubmit = (payload: any) => {

    mutateAsync(payload)
    
    console.log('payload: ', payload);
  };

  return <OwnerFormUI meta={OwnerFormMeta} onSubmit={onSubmit} isSubmitting={isSubmitting} isLoading={isLoading}/>;
};

export default OwnerFormHandler;
